import { Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../types/enums";
import { GradientButton } from "../ui";
import { useAppSelector } from "../../hooks";
import { selectPermissions } from "../../features/permissionsSlice";

export const NoCampaignsBlock = () => {
  const navigate = useNavigate();
  const { isAllowedEditCreateNewCampaign } = useAppSelector(selectPermissions);
  return (
    <Stack
      direction="row"
      gap="16px"
      borderRadius="6px"
      bgcolor="#ECEEF099"
      padding="16px"
      alignItems="flex-start"
      border="1px solid #D9D9D9"
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexGrow={1}
      >
        <Stack gap="4px">
          <Typography
            variant="subtitle1"
            color="custom.textDarkBlue"
            sx={{ fontWeight: 500 }}
          >
            No campaigns yet
          </Typography>
          <Typography variant="body1" color="text.secondary" maxWidth={"660px"}>
            Enter product details, choose campaign criteria, and optionally
            upload accounts and contacts to create your campaign.
          </Typography>
        </Stack>
        <GradientButton
          sx={{ textWrap: "nowrap" }}
          onClick={() => navigate(AppRoutes.CREATE_CAMPAIGN)}
          disabled={!isAllowedEditCreateNewCampaign}
        >
          Start New Campaign
        </GradientButton>
      </Stack>
    </Stack>
  );
};
